export const adminOptionsTabs = [
  { name: "Ordenes", href: "/admin/opciones?tab=Ordenes" },
  { name: "Subtareas", href: "/admin/opciones?tab=Subtareas" },
  { name: "Tareas", href: "/admin/opciones?tab=Tareas" },
];

// const paths = {
//   home:"/",
// panel:"/panel",
// orders:"/ots",
// newOrder:"/ots/new",
// ordenDetail:"/ots/detail/:orderCode",
// devices:"/equipos",
// deviceDetail:"/equipos/:code",
// path:"/orden-tecnica/:code",
// path:"/orden-tecnica/nueva",
// path:"/orden-tecnica/editar/:orderCode",
// path:"/ots/edit/:otCode",
// path:"/plan",
// path:"/admin",
// path:/reportes,
// path:/reports/:plantCode?/:from?/:to?,
// path:"/admin/:selected",
// path:"/plan",
// path:"/admin/usuarios",
// path:"/admin/equipos",
// path:"/admin/opciones",
// path:"/admin/plantas",
// path:/admin/plan,
// path:/admin/plan/:tab,
// path:"/admin/garrafas",
// path:"/admin/monitoreo",
// path:"/admin/carga_excel",
// path:"/admin/carga_frecuencias",
// path:"/admin/tech-config",
// path:*" element={<NotFound />} /,
// }
